
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r",
      function () {
        return require("private-next-pages/r/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r"])
      });
    }
  